export default __webpack_public_path__ + "static/media/thunderdome.764635b0.gif";